import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function OrderStatus(props) {
  const {
    orderStatus,
    orderStatusColor,
    testID = "",
    height = 20,
    width = 20,
  } = props;
  switch (orderStatus) {
    case "OrderCancelled":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
          testID={testID}
        >
          <Circle cx={10} cy={10} r={8} fill="#FF2E00" />
          <Path
            d="M10.733 10l3.115-3.115a.518.518 0 10-.733-.733L10 9.267 6.885 6.152a.518.518 0 10-.733.733L9.267 10l-3.115 3.115a.518.518 0 10.733.733L10 10.733l3.115 3.115a.517.517 0 00.733 0 .518.518 0 000-.733L10.733 10z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
          />
        </Svg>
      );

    case "OrderShipped":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.53 7.053l1.944 3.017c.06.093.092.2.092.31v3.017c0 .333-.29.603-.648.603H18c0-1.103-.897-2-2-2s-2 .897-2 2h-1.564c-.357 0-.648-.27-.648-.603V7.363c0-.333.29-.603.648-.603h4.537c.229 0 .44.111.556.293zM16.666 14a.668.668 0 00-1.334 0h1.334z"
            fill="#2F80ED"
          />
          <Path
            d="M14.381 8.056h2.226l1.556 2.593H14.38V8.056z"
            fill="#FAFAFA"
          />
          <Path
            d="M15.896 15.186a1.296 1.296 0 100-2.593 1.296 1.296 0 000 2.593z"
            fill="#2F80ED"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.438 4H3.561C3.252 4 3 4.28 3 4.625v.837H.648a.648.648 0 000 1.297H3v1.297H1.944a.648.648 0 000 1.297H3v1.295h-.758a.648.648 0 000 1.296H3v1.431c0 .345.252.625.563.625H5.31a1.947 1.947 0 011.941-2.055A1.947 1.947 0 019.194 14H12V4.625C12 4.28 11.748 4 11.437 4zm-4.834 9.89c0 .037.003.074.01.11H7.89a.648.648 0 10-1.287-.11z"
            fill="#2F80ED"
          />
          <Path
            d="M7.251 15.186a1.296 1.296 0 100-2.593 1.296 1.296 0 000 2.593z"
            fill="#2F80ED"
          />
        </Svg>
      );

    case "OrderProcessing":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.86 9.097A5.989 5.989 0 0013.993 12a5.988 5.988 0 004.124-1.638v4.844l-8.56 4.51L1 15.206V4.956L3.608 6.33 1 4.955 9.559.958l.718.335c-.203.16-.395.334-.575.519l-.143-.067-6.956 3.249 1.79.944 3.961-1.975a5.994 5.994 0 00-.277 3.004l-.895.44 1.167.615c.135.377.306.737.51 1.075L6.39 7.796l2.47 1.3zM3.51 11.439l.065-4.32-1.863-.981v8.637l7.133 3.759V9.896L6.38 8.597v3.713l-1.46-1.128-1.41.257z"
            fill="#2F80ED"
          />
          <Path
            d="M13.953.958a4.998 4.998 0 00-4.995 5c0 2.76 2.235 5 4.995 5a5.003 5.003 0 005.005-5c0-2.76-2.24-5-5.005-5z"
            fill="#2F80ED"
          />
          <Path
            d="M14.208 3.458h-.75v3l2.625 1.575.375-.615-2.25-1.335V3.458z"
            fill="#fff"
          />
        </Svg>
      );

    case "OrderNotFulfilled":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 18 20"
          fill="none"
          {...props}
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.86 9.097A5.989 5.989 0 0012.993 12a5.988 5.988 0 004.124-1.638v4.844l-8.56 4.51L0 15.206V4.956L2.608 6.33 0 4.955 8.559.958l.717.335a6.03 6.03 0 00-.574.519l-.143-.067-6.956 3.249 1.79.944 3.961-1.975a5.994 5.994 0 00-.277 3.004l-.895.44 1.167.615c.135.377.306.737.51 1.075L5.39 7.796l2.47 1.3zM2.51 11.439l.065-4.32-1.863-.981v8.637l7.133 3.759V9.896L5.38 8.597v3.713l-1.46-1.128-1.41.257z"
            fill="#000"
            fillOpacity={0.56}
          />
          <Path
            d="M12.953.958a4.998 4.998 0 00-4.995 5c0 2.76 2.235 5 4.995 5a5.003 5.003 0 005.005-5c0-2.76-2.24-5-5.005-5z"
            fill="#000"
            fillOpacity={0.56}
          />
          <Path
            d="M13.366 6l1.558-1.558a.259.259 0 10-.367-.366L13 5.634l-1.558-1.558a.259.259 0 10-.366.366L12.633 6l-1.557 1.558a.259.259 0 10.366.366L13 6.366l1.557 1.558a.259.259 0 10.367-.366L13.366 6z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.5}
          />
        </Svg>
      );

    case "OrderSuccessful":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
        >
          <Path
            d="M10 2c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zM7.832 13.432L4.96 10.56a.797.797 0 111.128-1.128L8.4 11.736l5.504-5.504a.797.797 0 111.128 1.128L8.96 13.432a.797.797 0 01-1.128 0z"
            fill="#27AE60"
          />
        </Svg>
      );

    case "OrderReturned":
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.816 9.576L6.77 9.024l4.063-1.897.98.457-3.997 1.992zm1.166 1.085l1.851.976 5-2.635-5-2.335-5 2.335 1.524.803-1.524-.803v5.988l5 2.635 5-2.635V9.002l-5 2.635-1.85-.976zm-1.644-.395L7.3 12.79l.824-.15.853.66v-2.17l1.44.76v5.045L6.25 14.74V9.693l1.088.573zm2.107.168l4.128-2.028 1.324.618-4.064 2.142-1.388-.732z"
            fill="#FF2E00"
          />
          <Path
            d="M18.333 11.067c0 4.466-3.551 8.1-7.916 8.1-4.366 0-7.917-3.634-7.917-8.1 0-.265.21-.48.47-.48.259 0 .47.215.47.48 0 3.937 3.13 7.139 6.977 7.139 3.847 0 6.977-3.203 6.977-7.139 0-3.936-3.13-7.138-6.977-7.138h-.815l1.165 1.334a.488.488 0 01-.037.678.462.462 0 01-.664-.038L8.401 3.996a.836.836 0 010-1.095L10.066.994a.464.464 0 01.663-.039c.194.177.21.48.038.679L9.602 2.968h.815c4.365 0 7.916 3.633 7.916 8.1z"
            fill="#FF2E00"
          />
        </Svg>
      );

    case "RequestApproved":
      return (
        <Svg
          width={width}
          height={height}
          fill={"none"}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.86 9.097A5.989 5.989 0 0 0 13.993 12a5.988 5.988 0 0 0 4.124-1.638v4.844l-8.56 4.51L1 15.206V4.956L3.608 6.33 1 4.956 9.559.958l.718.335c-.203.16-.395.334-.575.519l-.143-.067-6.956 3.249 1.79.944 3.961-1.974a5.994 5.994 0 0 0-.277 3.003l-.895.44 1.167.615c.135.377.306.737.51 1.075L6.39 7.796l2.47 1.301ZM3.51 11.439l.065-4.32-1.863-.981v8.637l7.133 3.759V9.896L6.38 8.597v3.713l-1.46-1.128-1.41.257Z"
            fill={orderStatusColor || "#00AB59"}
          />
          <Path
            d="M14 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5Zm-1.355 7.145L10.85 6.35a.498.498 0 1 1 .705-.705L13 7.085l3.44-3.44a.498.498 0 1 1 .705.705L13.35 8.145a.498.498 0 0 1-.705 0Z"
            fill={orderStatusColor || "#00AB59"}
          />
        </Svg>
      );

    default:
      return (
        <Svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          {...props}
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.86 9.097A5.989 5.989 0 0013.993 12a5.988 5.988 0 004.124-1.638v4.844l-8.56 4.51L1 15.206V4.956L3.608 6.33 1 4.955 9.559.958l.718.335c-.203.16-.395.334-.575.519l-.143-.067-6.956 3.249 1.79.944 3.961-1.975a5.994 5.994 0 00-.277 3.004l-.895.44 1.167.615c.135.377.306.737.51 1.075L6.39 7.796l2.47 1.3zM3.51 11.439l.065-4.32-1.863-.981v8.637l7.133 3.759V9.896L6.38 8.597v3.713l-1.46-1.128-1.41.257z"
            fill="#2F80ED"
          />
          <Path
            d="M13.953.958a4.998 4.998 0 00-4.995 5c0 2.76 2.235 5 4.995 5a5.003 5.003 0 005.005-5c0-2.76-2.24-5-5.005-5z"
            fill="#2F80ED"
          />
          <Path
            d="M14.208 3.458h-.75v3l2.625 1.575.375-.615-2.25-1.335V3.458z"
            fill="#fff"
          />
        </Svg>
      );
  }
}

export default OrderStatus;
